var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrademarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 122.88 55.84",
    style: {
      enableBackground: "new 0 0 122.88 55.84"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,0h52.45v13.8h-17.6v42.05H17.59V13.8H0V0L0,0z M60.07,0h22.7l8.76,33.97L100.26,0h22.62v55.84h-14.1V13.26L97.85,55.84 H85.1L74.2,13.26v42.58H60.07V0L60.07,0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrademarkIcon);
export default __webpack_public_path__ + "static/media/trademark-icon.083739379c585ae447cd757c302c9b45.svg";
export { ForwardRef as ReactComponent };